<script>
export default {
	lang: 'books',
	props: {
		uncatchedValidation: Object,
		config: Object,
		customizationRef: Object,
	},
	data() {
		return {
			customization: this.customizationRef,
		}
	},
	created() {
		this.$assignDeep(
			this.customization,
			{
				data: {
					name: null,
					name2: null,
					birthdate: null,
					lang: null,
				},
			},
			true
		)
	},
}
</script>

<template>
	<v-row class="flex-grow-1 flex-md-nowrap justify-center">
		<v-col cols="12" :style="{ maxWidth: $vuetify.breakpoint.mdAndUp ? '262px' : null }">
			<TextField
				v-model="customization.data.name"
				:label="$lang('Nombre – para quién es')"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
				:counter="config.nameMaxLen"
				:maxlength="config.nameMaxLen"
			/>
		</v-col>
		<v-col cols="12" :style="{ maxWidth: $vuetify.breakpoint.mdAndUp ? '262px' : null }">
			<TextField
				v-model="customization.data.name2"
				:label="$lang('Nombre – de parte de quién')"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
				:counter="config.name2MaxLen"
				:maxlength="config.name2MaxLen"
			/>
		</v-col>
		<v-col cols="12" :style="{ maxWidth: $vuetify.breakpoint.mdAndUp ? '196px' : null }">
			<DatePickerDialog
				v-model="customization.data.birthdate"
				:label="$lang('Fecha nacimiento')"
				:placeholder="$lang('dd/mm/aaaa')"
				dateTextFormat="DD/MM/YYYY"
				textfield-class="customization-tf"
				:textfield-attrs="{ dense: true, plain: true, solo: true, height: 50 }"
			/>
		</v-col>
		<div class="pa-3">
			<Select
				:label="$lang('Idioma')"
				:items="config.langs"
				v-model="customization.data.lang"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
			/>
		</div>
	</v-row>
</template>
